import React from "react";
import PropTypes from "prop-types";
const TIME_FRAME = {
  TEN_MINUTES: "TEN_MINUTES",
  HOURLY: "HOURLY",
  DAILY: "DAILY",
  WEEKLY: "WEEKLY",
  MONTHLY: "MONTHLY",
};

const TIME_UNIT_LABELS = {
  [TIME_FRAME.TEN_MINUTES]: "10分単位",
  [TIME_FRAME.HOURLY]: "1時間単位",
  [TIME_FRAME.DAILY]: "1日単位",
  [TIME_FRAME.WEEKLY]: "1週単位",
  [TIME_FRAME.MONTHLY]: "1か月単位",
};

const TimeUnitSelector = ({ timeUnit, onChange }) => (
  <select value={timeUnit} onChange={onChange} className="time-unit-selector" style={{ padding: "8px", borderRadius: "4px", border: "1px solid #ccc" }}>
    {Object.entries(TIME_UNIT_LABELS).map(([value, label]) => (
      <option key={value} value={value}>
        {label}
      </option>
    ))}
  </select>
);

TimeUnitSelector.propTypes = {
  timeUnit: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default TimeUnitSelector;
